import { request_detail, request_list, update_detail, create_detail, remove_detail } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice, refreshResource } from '@/commons/utils';
import configs from '@/configs'
import Vue from 'vue';
const endpoint = 'payment-request'
const viewTitle = 'yêu cầu giao hàng'

// initial state
const state = {
    loading: false,
    all: {},
    selected: {
        id: 0
    }
};

// getters
const getters = {};

// actions
const actions = {
    getList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list(endpoint, data => {
            commit('setList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getDetail({ commit }, id) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit("setLoading", { loading: true });
                request_detail(endpoint, data => {
                    commit('setDetail', data);
                    resolve(data);
                    commit("setLoading", { loading: false });
                }, Vue.http, id, this.state.authentication.token);
            }, 100)
        })
    },
    setDetail({ dispatch }, {data, id, ignore_reload}) {
        if(id > 0) {
            data.ModifiedBy = this.state.authentication.user.username;
            update_detail(endpoint, res => {
                if (res.data.status === 'fail') {
                    sendErrorNotice(`Không thể cập nhật ${viewTitle}.`)
                }
                else {
                    sendSuccessNotice(`Cập nhật ${viewTitle} thành công.`)
                    if(!ignore_reload) {
                        refreshResource();
                    }
                }
            }, Vue.http, data, id, this.state.authentication.token);
        }
        else {
            delete data.id;
            create_detail(endpoint, res => {
                if (res.data.status === 'fail') {
                    sendErrorNotice(`Không thể thêm mới ${viewTitle}.`)
                }
                else {
                    sendSuccessNotice(`Thêm mới ${viewTitle} thành công.`);
                    refreshResource();
                }
            }, Vue.http, data, this.state.authentication.token);
        }
    },
    removeDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        remove_detail(endpoint, res => {
            if (res.data.status === false) {
                sendErrorNotice(`Không thể xóa ${viewTitle}.`)
            }
            else {
                sendSuccessNotice(`Đã xóa ${viewTitle} thành công.`)
                refreshResource();
            }
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
    createFromPackages({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("setLoading", { loading: true });
            Vue.http.post(`${configs.API}/admin/api/${endpoint}/from-packages/`, data, {
                headers: { Authorization: 'Bearer ' + this.state.authentication.token }
            }).then(res => {
                commit("setLoading", { loading: false });
                if (res.data.status === 'fail') {
                    sendErrorNotice(res.data.reason || `Không thể tạo ${viewTitle} từ packages.`);
                    reject(res.data);
                }
                else {
                    sendSuccessNotice(`Tạo ${viewTitle} từ packages thành công.`);
                    resolve(res.data);
                }
            }).catch(err => {
                commit("setLoading", { loading: false });
                sendErrorNotice(`Lỗi khi tạo ${viewTitle} từ packages: ${err.message}`);
                reject(err);
            });
        });
    },
};

// mutations
const mutations = {
    setList(state, data) {
        state.all = data;
    },
    setDetail(state, item) {
        state.selected = item.data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
